import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { ChangeImage } from "../imports";
import { getFile } from "../redux/creators/fileCreators";
import OptionLabel from "./OptionLabel";
import { device } from "../../../utils/breakPoints";

/**
 * PDP block for current uploaded photo
 *
 * @returns {Object}
 */
export default function YourUploadedPhoto({ selectedProduct }) {
  const { file } = useSelector((state) => getFile(state));
  const image = URL.createObjectURL(file);
  return (
    <Container>
      <OptionLabel label={"Your Photo"} />
      <UploadedPhotoContainer>
        <ImageContainer>
          <Image src={image}></Image>
        </ImageContainer>
        <PhotoInfoContainer>
          <PhotoInfo>
            <SubText>{selectedProduct.title}</SubText>
            <PhotoName>{file.name}</PhotoName>
          </PhotoInfo>
          <ChangeImageContainer>
            <ChangeImage />
          </ChangeImageContainer>
        </PhotoInfoContainer>
      </UploadedPhotoContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
const UploadedPhotoContainer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  text-align: left;
  background-color: #ffffff;
`;
const ImageContainer = styled.div`
  height: 60px;
  @media ${device.tablet} {
    width: 20%;
  }
`;
const Image = styled.img`
  height: 60px;
  object-fit: cover;
  @media ${device.tablet} {
    width: 100%;
  }
`;
const PhotoInfoContainer = styled.div`
  width: 100%;
  padding: 6px 12px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  @media ${device.tablet} {
    width: 80%;
  }
`;
const PhotoInfo = styled.div`
  width: 100%;
  @media ${device.tablet} {
    width: 70%;
  }
`;
const SubText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const PhotoName = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ChangeImageContainer = styled.div`
  width: 100%;
  text-align: right;
`;
